import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import useCurrentUser from '../../../../hooks/useCurrentUser';
import {useOpeningHoursDiff} from '@arnsbogroup/react-voicearchive/hooks';
import HandoverDetails from "containers/HandoverPage/components/HandoverDetails";
import { FormattedRelativeTime, useIntl } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'
import { useHistory } from 'react-router-dom'

const HandoversWidget = ({widget}) => {
  const mounted = useRef(false);
  const { name } = useCurrentUser();
  const history = useHistory()
  
  const [handovers, setHandovers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [title, setTitle] = useState('');
  const [selectedHandoverId, setSelectedHandoverId] = useState(null)

  const { formatDate, formatTime } = useIntl()

  useEffect(() => {
    mounted.current = true;
    fetch('coordinatordashboard/Handovers')
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setHandovers(data.data.handovers);
        setOrders(data.data.orders);
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  const showOrderDetails = (uid) => {
    history.push(`/orders/${uid}`)
  }

  const showHandoverDialog = (uid) => {
    setSelectedHandoverId(uid);
  }

  const timeSince = (unix) => {
    const { value, unit } = selectUnit(unix * 1000);
    return <FormattedRelativeTime value={value} unit={unit} />
  }

  const getOrderRows = () => {
    return orders?.map((order) => {
      return (
        <tr
          key={order['uid']}
          title={order['deal_id']}
          onClick={() => showOrderDetails(order['uid'])}
          className="bg-red-50 hover:bg-red-300 cursor-pointer"
        >
          <td className="border-b px-4 py-2 w-4/6 space-x-2">
            <span>D{order['deal_id']} missing PM!</span>
          </td>
          <td
            className="border-b px-4 py-2 w-2/6 text-right"
            title={`${formatDate(order['crdate'] * 1000)} ${formatTime(order['crdate'] * 1000)}`}>
            {timeSince(order['crdate'])}
            <span className="text-xs w-2 inline-block ml-2">
              <i className="block rounded-full w-2 h-2 bg-red-600" title="Has no Project Manager"></i>
            </span>
          </td>
        </tr>
      );
    });
  }

  const getWaitTime = (created_at) => {
    const hourDiff = useOpeningHoursDiff(created_at, new Date()).hours;
    if(hourDiff > 4) {
      return <i className="block rounded-full w-2 h-2 bg-red-600" title="Has been waiting for more than 3 hours"></i>
    } else if (hourDiff > 3) {
      return <i className="block rounded-full w-2 h-2 bg-yellow-500" title="Has been waiting for more than 30 min."></i>
    } else {
      return <i className="block rounded-full w-2 h-2 bg-green-500" title="Has been waiting for less than 30 min."></i>
    }
  }

  const getHandoverRows = () => {
    return Object.values(handovers)?.map((handover) => {
      return (
        <tr
          key={handover['uid']}
          title={handover['deal_id']}
          onClick={() => showHandoverDialog(handover['uid'])}
          className={`${handover['currently_at'] == name ? 'bg-yellow-100 hover:bg-gray-200 cursor-pointer' : 'hover:bg-gray-200 cursor-pointer'}`}
        >
          <td className="border-b px-4 py-2 w-4/6 space-x-2">
            { handover['language'] && (
              <img
                  src={`https://hatscripts.github.io/circle-flags/flags/${{'da':'dk', 'de':'de', 'en-GB':'gb'}[handover['language']]}.svg`}
                  className="w-4 inline-block"
              />
            )}
            <span>D{handover['deal_id']}</span>

            { handover['currently_at'] && (
              <span>at {handover['currently_at']}</span>
            )}

            { handover['defered_by'] && (
              <span className="p-1 rounded-sm font-medium text-xs ml-2 bg-yellow-400 text-white">
                <i className="fa fa-pause mr-1"></i> {handover['defered_by']}
              </span>
            )}

          </td>

          <td
            className="border-b px-4 py-2 w-2/6 text-right"
            title={handover['created_at']}>
            {timeSince(handover['created_at'])}

            <span className="text-xs w-2 inline-block ml-2">
              {/* { getWaitTime(handover['created_at']) } */}
            </span>
          </td>

        </tr>
      );
    });
  }

  const getRows = () => {
    if (
      handovers.length == 0 &&
      orders.length == 0
    ) {
      return (
        <tr key={'none'}>
          <td className="px-3 py-2">No handovers is waiting in backlog.</td>
        </tr>
      )
    }

    return (
      <>
        { getHandoverRows() }
        { getOrderRows() }
      </>
    )
  }

  
  const widget_id = `ID_${widget.widgetId}`;
  return (
    <>
      <li className="bg-white border m-4 shadow rounded border-gray-400" key={widget_id} id={widget_id}>
        <WidgetHeader widget={widget} widgetTitle={title} />

        <div className="py-2 px-4 flex justify-between items-center text-opacity-50 hover:text-opacity-100">
          <div className="text-xs text-gray-500">
              <div className="text-xs flex items-center space-x-1">
                <div className="inline-block w-4 h-4 rounded-full bg-gray-100 border border-gray-200"></div>
                <span className="text-gray-500">= Prefered handling language</span>
              </div>
          </div>
          <div className="space-x-2 flex">
              <div className="text-xs flex items-center space-x-1">
                <div className="inline-block w-4 h-4 rounded bg-yellow-200"></div>
                <span className="text-gray-500">= Requires your attention</span>
              </div>
              <div className="text-xs flex items-center space-x-1">
                <div className="inline-block w-4 h-4 rounded border border-gray-200"></div>
                <span className="text-gray-500">= Backlog</span>
              </div>
          </div>
        </div>

        <div className="border-b py-2 px-3 flex justify-between items-center text-opacity-50 hover:text-opacity-100">
          <table className="w-full table-fixed text-xs border-t">
            <tbody>
            { getRows() }
            </tbody>
          </table>

        </div>
      </li>
      <HandoverDetails handoverId={selectedHandoverId} onClose={() => setSelectedHandoverId(null)}/>
    </>
  );

}

export default HandoversWidget;
